<template>
  	<div class="sub-container">
		<div id="brand-main-container">

			<div class="brand-video">
				<div class="brand-video-frame">
					<video :src="nowVideo" type="video/mp4" autoplay playsinline muted @ended="videoPlayer('next')" />
				</div>
			</div>

			<div class="brand-slide">
				<div class="slide-main">
					<div class="slide-banr">
						<h1>
							IT <br />
							Entertainment
						</h1>
						<h2>IT 프로젝트의 세상에는 과연 무엇이 있을까요?</h2>
						<div class="flex sp-tw">
							<span>
								일하는 즐거움, 성공하는 짜릿한 쾌감도 있습니다. <br />
								하나 더! <br />
								처음부터 끝까지, 당신 곁에 누군가가 <br />
								당신을 도와주기 위하여 존재한다는 새로운 사실입니다. <br />
								누군가와 함게 하여 더 행복하고, 더 성공할 수 있다면, <br />
								그레이트 프로가 당신 곁에 있기 때문입니다.
							</span>
							<img src="/images/brand-img-01.png">
						</div>
					</div>
				</div>
			</div>
			<div class="brand-slide">
				<div class="slide-main">
					<div class="slide-banr">
						<h1>
							Great <br />
							Pro
						</h1>
						<h2>당신이 그레이트 프로입니다.</h2>
						<div class="flex sp-tw">
							<span>
								우리는 IT 프로페셔널리스트를 꿈꾸는 당신을 존경합니다.<br />
								새로운 기술을 통해 모두가 만족하는 솔루션을 찾아내는 일은<br />
								쉽지 않지만, 모두의 행복을 크게 하는 일입니다.<br />
								단순히 기술의 발휘에 그치지 않고, 새로운 솔루션을 탄생시키는 사람,<br />
								우리 모두의 행복은<br />
								당신의 가슴과 두뇌, 손끝에서 창조됩니다.
							</span>
							<img src="/images/brand-img-02.png">
						</div>
					</div>
				</div>
			</div>
			<div class="brand-slide">
				<div class="slide-main">
					<div class="slide-banr">
						<h1>
							Pro <br />
							Allience
						</h1>
						<h2>우리는 IT 프로의 얼라이언스 혁명을 시작합니다.</h2>
						<div class="flex sp-tw">
							<span>
								우리는 단순한 채용, 이직, 커리어 관리에 <br />
								멈추지 않습니다. <br />
								그레이트 프로는 IT 프로와 프로젝트간의 <br />
								행복한 연합, 프로 얼라이언스를 통해  <br />
								지속가능한 성공의 협력체계를 구축합니다.  <br />
								전문성, 신뢰, 보증, 존경 <br />
								이 네 가지는 그레이트 프로의 변하지 않는 원칙입니다.
							</span>
							<img src="/images/brand-img-03.png">
						</div>
					</div>
				</div>
			</div>
			<div class="brand-slide">
				<div class="slide-main">
					<div class="slide-banr">
						<h1>
							Connect <br />
							Value
						</h1>
						<h2>가치와 가치를 연결합니다.</h2>
						<div class="flex sp-tw">
							<span>
								IT 프로 한 분 한 분은 그 존재 자체로 <br />
								존경스러운 가치입니다.<br />
								그레이트 프로와 함께 하는 모든 기업과 프로젝트 역시<br />
								소중한 가치 그 자체입니다.<br /><br />


								그레이트 프로는 가치와 가치를 연결합니다.<br />
								가치와 가치가 만나<br />
								더 큰 가치, 그레이트 밸류가 탄생합니다.
							</span>
							<img src="/images/brand-img-04.png">
						</div>
					</div>					
				</div>
			</div>

			<div class="brand-pron">
				<div class="inner">
					<img src="/images/brand-pron-logo.png">
					<span>
						프로엔솔루션은 <br />
						PMO, SI, SM, 컨설팅 등 <br />
						금융 IT 서비스를 <br />
						선도합니다.
						<p>
							<a target="_blank" href="https://www.pronsolution.com">더보기</a>
						</p>
					</span>
				</div>
			</div>

			<div class="brand-pro">
				<div class="mainsection-greatpro-txt">
					<div class="inner">
						<div class="tit">
							대한민국 최초의 초정예 플랫폼입니다. <br />
							금융 IT 얼라이언스 플랫폼, 그레이트 프로
						</div>
						<div class="count">
							<div>
								100명 <br />
								<span>
									초정예 금융IT 프로 얼라이언스<br />
									회원 수
								</span>
							</div>
							<div>
								17개 <br />
								<span>
									금융 그룹 얼라이언스<br />
									고객 수
								</span>
							</div>
							<div>
								24건 <br />
								<span>
									대형 금융IT 프로젝트<br />
									연간 의뢰 수
								</span>
							</div>
							<div>
								100% <br />
								<span>
									금융IT 프로젝트 얼라이언스<br />
									만족지수
								</span>
							</div>
						</div>
					</div>        
				</div>
			</div>	

			<div class="brand-partner">
				<div class="mainsection-client">
					<div class="inner">
						<div class="tit">
							그레이트 프로는 대한민국 탑티어 고객사와 <br />
							프로젝트 성공 경험을 공유하고 있습니다.
						</div>
						<img src="/images/great-pro-client.png">
					</div>
				</div>
			</div>


			<!---->
			<!-- <main>
				<section>
					<div class="brand-video">
						<div class="brand-video-frame">
							<video :src="nowVideo" type="video/mp4" autoplay playsinline muted @ended="videoPlayer('next')" />
							<div class="video-cursor-frame">
								<div id="slide-btn" class="btn-prev" @click="btnClick('prev')">
									&lt;
								</div>
								<div id="slide-btn" class="btn-next" @click="btnClick('next')">
									&gt;
								</div>
							</div>
						</div>
					</div>
				</section>

				<section>
					<div class="brand-slide">
						<div class="slide-main">
							<div class="slide-banr">
								<h1>
									IT <br />
									Entertainment
								</h1>
								<h2>IT 프로젝트의 세상에는 과연 무엇이 있을까요?</h2>
								<span>
									일하는 즐거움, 성공하는 짜릿한 쾌감도 있습니다. <br />
									하나 더! <br />
									처음부터 끝까지, 당신 곁에 누군가가 <br />
									당신을 도와주기 위하여 존재한다는 새로운 사실입니다. <br />
									누군가와 함게 하여 더 행복하고, 더 성공할 수 있다면, <br />
									그레이트 프로가 당신 곁에 있기 때문입니다.
								</span>
								<img src="/images/brand-img-01.png">
							</div>
						</div>
					</div>
				</section>

				<section>
					<div class="brand-slide">
						<div class="slide-main">
							<div class="slide-banr">
								<h1>
									Great <br />
									Pro
								</h1>
								<h2>당신이 그레이트 프로입니다.</h2>
								<span>
									우리는 IT 프로페셔널리스트를 꿈꾸는 당신을 존경합니다.<br />
									새로운 기술을 통해 모두가 만족하는 솔루션을 찾아내는 일은<br />
									쉽지 않지만, 모두의 행복을 크게 하는 일입니다.<br />
									단순히 기술의 발휘에 그치지 않고, 새로운 솔루션을 탄생시키는 사람,<br />
									우리 모두의 행복은<br />
									당신의 가슴과 두뇌, 손끝에서 창조됩니다.
								</span>
								<img src="/images/brand-img-02.png">
							</div>
						</div>
					</div>
				</section>

				<section>
					<div class="brand-slide">
						<div class="slide-main">
							<div class="slide-banr">
								<h1>
									Pro <br />
									Allience
								</h1>
								<h2>우리는 IT 프로의 얼라이언스 혁명을 시작합니다.</h2>
								<span>
									우리는 단순한 채용, 이직, 커리어 관리에 <br />
									멈추지 않습니다. <br />
									그레이트 프로는 IT 프로와 프로젝트간의 <br />
									행복한 연합, 프로 얼라이언스를 통해  <br />
									지속가능한 성공의 협력체계를 구축합니다.  <br />
									전문성, 신뢰, 보증, 존경 <br />
									이 네 가지는 그레이트 프로의 변하지 않는 원칙입니다.
								</span>
								<img src="/images/brand-img-03.png">
							</div>
						</div>
					</div>
				</section>

				<section>
					<div class="brand-slide">
						<div class="slide-main">
							<div class="slide-banr">
								<h1>
									Connect <br />
									Value
								</h1>
								<h2>가치와 가치를 연결합니다.</h2>
								<span>
									IT 프로 한 분 한 분은 그 존재 자체로 <br />
									존경스러운 가치입니다.<br />
									그레이트 프로와 함께 하는 모든 기업과 프로젝트 역시<br />
									소중한 가치 그 자체입니다.<br /><br />


									그레이트 프로는 가치와 가치를 연결합니다.<br />
									가치와 가치가 만나<br />
									더 큰 가치, 그레이트 밸류가 탄생합니다.
								</span>
								<img src="/images/brand-img-04.png">
							</div>
						</div>
					</div>
				</section>

				<section>					
					<div class="brand-slide">
						<div class="slide-main">
							<div class="brand-text">
								<div class="inner-txt">
									대한민국 최초의 초정예 플랫폼입니다. <br />
									금융 IT 얼라이언스 플랫폼, 그레이트 프로
								</div>
							</div>								
							<swiper class="swiper" :options="swiperOption">
								<swiper-slide>
									<div class="slide-banr">
										<h1>
											IT <br />
											Entertainment
										</h1>
										<h2>IT 프로젝트의 세상에는 과연 무엇이 있을까요?</h2>
										<span>
											일하는 즐거움, 성공하는 짜릿한 쾌감도 있습니다. <br />
											하나 더! <br />
											처음부터 끝까지, 당신 곁에 누군가가 <br />
											당신을 도와주기 위하여 존재한다는 새로운 사실입니다. <br />
											누군가와 함게 하여 더 행복하고, 더 성공할 수 있다면, <br />
											그레이트 프로가 당신 곁에 있기 때문입니다.
										</span>
										<img src="/images/brand-img-01.png">
									</div>
								</swiper-slide>
								<swiper-slide>
									<div class="slide-banr">
										<h1>
											Great <br />
											Pro
										</h1>
										<h2>당신이 그레이트 프로입니다.</h2>
										<span>
											우리는 IT 프로페셔널리스트를 꿈꾸는 당신을 존경합니다.<br />
											새로운 기술을 통해 모두가 만족하는 솔루션을 찾아내는 일은<br />
											쉽지 않지만, 모두의 행복을 크게 하는 일입니다.<br />
											단순히 기술의 발휘에 그치지 않고, 새로운 솔루션을 탄생시키는 사람,<br />
											우리 모두의 행복은<br />
											당신의 가슴과 두뇌, 손끝에서 창조됩니다.
										</span>
										<img src="/images/brand-img-02.png">
									</div>
								</swiper-slide>
								<swiper-slide>
									<div class="slide-banr">
										<h1>
											Pro <br />
											Allience
										</h1>
										<h2>우리는 IT 프로의 얼라이언스 혁명을 시작합니다.</h2>
										<span>
											우리는 단순한 채용, 이직, 커리어 관리에 <br />
											멈추지 않습니다. <br />
											그레이트 프로는 IT 프로와 프로젝트간의 <br />
											행복한 연합, 프로 얼라이언스를 통해  <br />
											지속가능한 성공의 협력체계를 구축합니다.  <br />
											전문성, 신뢰, 보증, 존경 <br />
											이 네 가지는 그레이트 프로의 변하지 않는 원칙입니다.
										</span>
										<img src="/images/brand-img-03.png">
									</div>
								</swiper-slide>
								<swiper-slide>
									<div class="slide-banr">
										<h1>
											Connect <br />
											Value
										</h1>
										<h2>가치와 가치를 연결합니다.</h2>
										<span>
											IT 프로 한 분 한 분은 그 존재 자체로 <br />
											존경스러운 가치입니다.<br />
											그레이트 프로와 함께 하는 모든 기업과 프로젝트 역시<br />
											소중한 가치 그 자체입니다.<br /><br />


											그레이트 프로는 가치와 가치를 연결합니다.<br />
											가치와 가치가 만나<br />
											더 큰 가치, 그레이트 밸류가 탄생합니다.
										</span>
										<img src="/images/brand-img-04.png">
									</div>
								</swiper-slide>
								<div class="swiper-pagination" slot="pagination"></div>
							</swiper>						
						</div>
					</div>					
				</section>

				<section>
					<div class="brand-pron">
						<div class="inner">
							<img src="/images/brand-pron-logo.png">
							<span>
								프로엔솔루션은 <br />
								PMO, SI, SM, 컨설팅 등 <br />
								금융 IT 서비스를 <br />
								선도합니다.
							</span>
						</div>
					</div>
				</section>
			</main> -->
		</div>
  	</div>
</template>

<script>

import {gsap, CSSPlugin, ScrollTrigger} from 'gsap/all';
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CSSPlugin);
import { brandMeta } from '@/utils/meta';

// import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
// import 'swiper/css/swiper.css'

export default {
	metaInfo : brandMeta,
    components: {},
	
	data() {
		return {
		    videoList : ['greatpro_brand01_dolphin.mp4', 'greatpro_brand02_skydive.mp4', 'greatpro_brand03_forest.mp4'],
		    nowVideo : '',
		    videoIdx : 0,

		    lastScrollTop : 0,
		    headerVisible : true, // 스크롤에 따른 헤더 노출여부

		    // swiperOption: {
			// 	direction: 'vertical',
			// 	mousewheelControl: false,
            //     slidesPerView: 1,
            //     pagination: {
            //         el: '.swiper-pagination',
            //         clickable: true
            //     },
			// 	autoplay: {
            //         delay: 4000,
            //         disableOnInteraction: false
            //     },
            // },
		}
	},
	beforeMount(){
	},
    created() {
    },

	mounted : function() {
		this.scrollAnimation();
		this.videoPlayer('start');

		window.addEventListener('scroll', this.onScroll);
	},

	beforeDestroy() {
		window.removeEventListener('scroll', this.onScroll);
	},

	methods: {
		onScroll () { // 스크롤에 따른 헤더 노출
			if(screen.width < 1024){
				const delta = 15;
				var tmpLastScrollTOP = this.lastScrollTop;
				var curScrollTOP = document.documentElement.scrollTop; // 현재 스크롤 위치
				
				if(Math.abs(tmpLastScrollTOP - curScrollTOP) <= delta) return;

				if((curScrollTOP > 150) && (curScrollTOP > tmpLastScrollTOP) && (tmpLastScrollTOP > 0)) {
					this.headerVisible = false;
				} else{
					this.headerVisible = true;
				}

				this.lastScrollTop = curScrollTOP;
			}
		},
		videoPlayer(val) {
			switch(val) {
				case 'next' : 
					if(this.videoIdx == this.videoList.length-1) {
						this.videoIdx = 0;	
					} else {
						this.videoIdx++;
					}
					this.nowVideo = '/video/' + this.videoList[this.videoIdx];
					break;
				case 'prev' :
					if(this.videoIdx == 0) {
						this.videoIdx = this.videoList.length-1;	
					} else {
						this.videoIdx--;
					}
					this.nowVideo = '/video/' + this.videoList[this.videoIdx];
					break;
				default : 
					this.nowVideo = '/video/' + this.videoList[this.videoIdx];
				}
		},
		btnClick(val) {
			if(val == 'next') {
				this.videoPlayer('next');
			} else if(val == 'prev') {
				this.videoPlayer('prev');
			}
		},
		scrollAnimation(){
			// 작업중
			const $scrollBox1 = this.$refs.intro_box1;
			const $roundBox1 = this.$refs.round_box1;
			const $roundBox2 = this.$refs.round_box2;
			const intro_box2 = gsap.utils.toArray('.intro-box2');
			const $roundBox3 = this.$refs.round_box3;
			const $scrollBox2 = this.$refs.intro_box4;
			const p_box = gsap.utils.toArray('.p-box');
			
			gsap.fromTo(
				$scrollBox1, // 이벤트 적용 위치
				{ x: 1200 }, // 시작위치
				{ 
					x : 0,
					scrollTrigger : {
						trigger : $scrollBox1,
						start : "top bottom",
						end : "top top",
						// markers : true,
						scrub : true,
					},
				} // 종료 위치
			);

			gsap.fromTo(
				$roundBox1,
				{ x : 0 },
				{ 
					x : -1200,
					scrollTrigger : {
						trigger : $roundBox1,
						start : "top bottom",
						end : "bottom top",
						// markers : true,
						scrub : true,
					},
				}
			)

			gsap.fromTo(
				$roundBox2,
				{ x : 0 },
				{ 
					x : 1300,
					scrollTrigger : {
						trigger : $roundBox2,
						start : "top bottom",
						end : "bottom top",
						// markers : true,
						scrub : true,
					},
				}
			)

			intro_box2.forEach(box => {
				gsap.fromTo(
					box, 
					{ x : 1200 , opacity : 0},
					{
						x : 0,
						opacity : 1,
						scrollTrigger : {
							trigger : box,
							start : "top 80%",
							end : "90% bottom",
							scrub : true,
							// markers : true,
						}
					}
					);
			});

			gsap.fromTo(
				$roundBox3,
				{ x : 0 },
				{ 
					x : -1500,
					scrollTrigger : {
						trigger : $roundBox3,
						start : "top bottom",
						end : "bottom top",
						// markers : true,
						scrub : true,
					},
				}
			);

			gsap.fromTo(
				$scrollBox2, // 이벤트 적용 위치
				{ x: -1200, opacity : 0 }, // 시작위치
				{ 
					x : 0,
					opacity : 1,
					scrollTrigger : {
						trigger : $scrollBox2,
						start : "top bottom",
						end : "70% 80%",
						// markers : true,
						scrub : true,
					},
				} // 종료 위치
			);

			p_box.forEach(box => {
				// gsap.from( box, { 
				// 		scrollTrigger : box,
				// 		duration : 1,
				// 		autoAlpha : 0,
				// 		scale : 1.5,
				// 		width : 0,
				// 		start : 'top 90%',
				// 		// end : "top 90%",
				// 		// stagger : 0.07,
				// 		// markers : true,
				// 		// rotation : -80,
				// 		// skew: 90,
				// 		// ease : 'power1.easeNone'
				// 	}
				// );
				let box_timeLine = gsap.timeline({
					scrollTrigger : {
						trigger : box,
						start : 'top 95%',
						// markers : true,
					}
				});
				box_timeLine.from(box, {
						duration : 1,
						autoAlpha : 0,
						scale : 1.5,
						width : 0,
				});
			});


			/********** [ MOBILE ] **********/
			 /* 3. 텍스트 영역 */
			const m_intro_box_list = gsap.utils.toArray('.m-intro-box');

			m_intro_box_list.forEach(element => {
				const mIntroBoxList_timeLine = gsap.timeline({
					scrollTrigger : {
						trigger : element,
						start : "top 95%",
						// markers : true,
						
					}
				});
				mIntroBoxList_timeLine.from(element.querySelector('.m-intro-tit'), {
					y: 70,
					opacity: 0, 
					duration: 0.4
				});
				mIntroBoxList_timeLine.from(element.querySelector('.m-intro-subtit'), {
					y: 70,
					opacity: 0, 
					duration: 0.4
				});
				mIntroBoxList_timeLine.from(element.querySelector('.m-intro-cont'), {
					y: 70,
					opacity: 0, 
					duration: 0.4
				});
				mIntroBoxList_timeLine.from(element.querySelector('.m-intro-button'), {
					y: 70,
					opacity: 0, 
					duration: 0.4
				});

			});

			/* 5. 포인트 영역 */
			const m_point_box_list = gsap.utils.toArray('.m-point-box');

			m_point_box_list.forEach(element => {
				const mPointBoxList_timeLine = gsap.timeline({
					scrollTrigger : {
						trigger : element,
						start : "top 95%",
						// markers : true,
					}
				});
				mPointBoxList_timeLine.from(element.querySelector('.m-point-box-tit'), {
					y: 100,
					opacity: 0, 
					duration: 0.4
				});
				mPointBoxList_timeLine.from(element.querySelector('.m-point-box-cont'), {
					y: 100,
					opacity: 0, 
					duration: 0.4
				});
			});
			
		}

	},
};
</script>